// DataTable.jsx
import React, { useEffect, useState } from "react";
import { Table, Spin, Alert, Card, message, Row } from "antd";
import axios from "axios";
import Cookies from "universal-cookie";
import { Morakasi as mo } from "../../Model/dbo/Morakasi";
import { DELMorakasiForUser, GetAllMorakasiForUser } from "../../RestAPI/dbo/Morakasiapi";
import NewMorkasi from "./NewMorakasi";
import dayjs from 'dayjs';
import jalaliday from 'jalaliday';
import { Button, Form, Input, Popconfirm } from 'antd';
import { DeleteOutlined, QuestionCircleOutlined, WarningOutlined } from "@ant-design/icons";
import { isDisabled } from "@testing-library/user-event/dist/utils";
dayjs.extend(jalaliday);

const Morakasi = () => {

  const [data, setParts] = useState(Array<mo>); // برای ذخیره داده‌ها

  const [loading, setLoading] = useState(true); // وضعیت بارگذاری
  const [error, setError] = useState(null); // برای مدیریت خطاها
  const handleDelete = async (key1: number, key2: number,key3:string,key4:string,key5:string) => {
    try {
      if( key4<=key5  && key3==="منتظر تایید")
      {
       const s=await DELMorakasiForUser(key1, key2);
       if(s==true){
        message.success("درخواست با موفقیت حذف شد");
        fetchData();
       }
      }
      else{
        message.error("مجاز به حذف مرخصی نمی باشید");
      }
       }
     catch (err) {
      message.error("خطا در حذف درخواست");
     
    }
  };

  // تعریف ستون‌های جدول
  const columns = [
    {
      title: 'عملیات',
      dataIndex: 'operation',
      
      render: (text2:any, record:any) =>
         <Popconfirm title="برای حذف اطمینان دارید?" onConfirm={() => handleDelete(record.ID,record.PersonelID,record.Status,record.SaveDate,record.Date)}  okText="بله"
          cancelText="خیر">
            <a>حذف</a>
         </Popconfirm>
       
    },
    {
      title: 'کد درخواست',
      dataIndex: 'ID',
      key: 'ID',
    },
    {
      title: 'کد پرسنلی',
      dataIndex: 'PersonelID',
      key: 'PersonelID',
    },
    {
      title: 'تاریخ مرخصی',
      dataIndex: 'Date',
      key: 'Date',
    },
    {
      title: 'تاریخ درخواست',
      dataIndex: 'SaveDate',
      key: 'SaveDate',
    },
    {
      title: 'تاریخ تایید مرخصی',
      dataIndex: 'ConfirmDate',
      key: 'ConfirmDate',
    },
    
    {
      title: 'از ساعت',
      dataIndex: 'StartTime',
      key: 'StartTime',
    },
    {
      title: 'تا ساعت',
      dataIndex: 'EndTime',
      key: 'EndTime',
    },
    {
      title: 'وضعیت درخواست',
      dataIndex: 'Status',
      key: 'Status',
    },
    {
      title: 'روز مرخصی',
      dataIndex: 'Day',
      key: 'Day',
    },
    {
      title: 'پس از زمان',
      dataIndex: 'IsPast',
      key: 'IsPast',
    },
  ];

  async function fetchData() {
    const list = await GetAllMorakasiForUser();
    setParts(list);
  }
  useEffect(() => {
    fetchData();
  }, []);


  if (error) {
    return <Alert message="خطا" description="در بارگذاری داده‌ها مشکلی پیش آمد." type="error" showIcon />;
  }

  return (
    <>

      <Card
        title="درخواست جدید"
        style={{ margin: 10 }}
      >

        <NewMorkasi loadList={fetchData} />
      </Card>
      <Card
        title="لیست مرخصی ها"
        style={{ margin: 10 }}
      >
        <Table
          bordered
          dataSource={data}
          columns={columns}
          scroll={{ x: 'max-content' }} 
        />
      </Card>
    </>

  );
};

export default Morakasi;
